import React, { useState, useEffect } from "react";
import {
  MULTI_CHOICE,
  RULE_SUGESSTION_OPTIONS,
  RULE_NAME_MANDATORY_MESSAGE,
  RULE_VALIDATION_MESSAGE,
  RULE_SAVE_MESSAGE,
  RULE_UPDATE_MESSAGE,
  RULE_EMPTY_STRING,
  RULE_FUNCTION_SUBMODEL,
  RULE_FUNCTION_SUBMODEL_FIELD,
  RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
  RULE_FUNCTION_FIELD,
  RULE_FUNCTION_CATEGORY,
  RULE_FUNCTION_PARENT,
  RULE_FUNCTION_CHILD,
  RULE_DONE,
  RULE_ADD_FIELD,
  RULE_EDIT,
  RULE_FUNCTION_RULE_NAME,
  RULE_RULE,
  RULE_FUNCTION_DESCRIPTION,
  RULE_DESCRIPTION,
  RULE_USE_SELECTED_ITEM_ATTRIBUTE, RANGE_FIELD,
} from "../../ISRConstants";
import TextField from "Components/DesignSystem/TextField/TextField";
import Checkbox from "Components/DesignSystem/Checkbox/Checkbox";
import FieldTitle from "Components/DesignSystem/FieldTitle/FieldTitle";
import MathOperator from "../MathOperator/mathOperatorComponent";
import SelectOptionsView from "../SelectOptionsView";
import RuleInputComponent from "./RuleInput";
import {
  RuleObjectStateType,
  RuleObjectType,
} from "../../Pages/DefineModel/model";
import { toast } from 'Components/DesignSystem/Toast/useToast';
import {
  TConnector,
  TField,
  TFieldDataConfiguration,
  TIndexState,
  TProductCategory,
  TSubmodel,
  TUpsertISRProjectDataModelsInput,
  TFieldAdditionalData,
  RuleSuggestionOptionType,
} from "../../Pages/DefineModel/model";
import { TAttributeChoice } from "types/Pages/ProductDelta";

type MathRuleComponentPropType = {
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  setUserProjectDataModels: React.Dispatch<
    React.SetStateAction<TUpsertISRProjectDataModelsInput>
  >;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo?: TIndexState;
  editId?: any;
  ruleType: any;
  toggleMenu: () => void;
  createISRProject:(isRuleUpdate: boolean)=>void;
  featureType?: string;
};

type commandType = {
  id: number;
  label: string;
  description: string;
  hasOptions: boolean;
  onClickHandler: Function;
  child: [];
  type: string;
  choiceType: string;
  subModel?: string | null;
};

const MathRuleComponent = ({
  selectedItem,
  setUserProjectDataModels,
  userProjectDataModels,
  indexInfo,
  editId,
  ruleType,
  toggleMenu,
  createISRProject,
  featureType,
}: MathRuleComponentPropType) => {
  const isCategoryFeature = featureType === RULE_FUNCTION_CATEGORY;
  const [rules, setRules] = useState<RuleObjectStateType[]>([]);
  const [ruleState, setRuleState] = useState<string | undefined>(
    RULE_EMPTY_STRING
  );
  const [createRule, setCreateRule] = useState<boolean | null>(false);
  const [showMath, setShowMath] = useState<boolean>(false);
  const [dynamicCommandOption, setDynamicCommandOption] = useState<any[]>();
  const [commandOptions, setCommandOptions] = useState<
    RuleSuggestionOptionType[]
  >(RULE_SUGESSTION_OPTIONS);
  const [showSelectOptions, setShowSelectOptions] = useState<boolean>(false);
  const [selectRef, setSelectRef] = useState<any>();
  const [inputRef, setInputRef] = useState<any>();
  const [ruleScope, setRuleScope] = useState<any>();
  const [propName, setPropName] = useState<string>(RULE_EMPTY_STRING);
  const [hierarchyObject, setHierarchyObject] = useState<{ subModel: string, category: string, field: string }>({ subModel: "", category: "", field: "" });
  const [mergeFieldList, setMergeFieldList] = useState<
    (
      | TField
      | {
          id: string | null | undefined;
          type: string;
          name: string;
          belongsToDataModel: boolean;
          dataConfiguration: TFieldDataConfiguration;
          additionalData: TFieldAdditionalData;
          rules: RuleObjectType[];
        }
    )[]
  >();
  const [ruleObj, setRuleobj] = useState<RuleObjectStateType | null>(null);
  const [ruleName, setRuleName] = useState<string>();
  const [description, setDescription] = useState<string>();
  const [useSelectedItemAttribute, setUseSelectedItemAttribute] =
    useState<boolean>(false);

  useEffect(() => {
    if (editId) fetchEditState();
    else {
      fetchEditState();
      setRuleName(RULE_EMPTY_STRING);
      setDescription(RULE_EMPTY_STRING);
      setUseSelectedItemAttribute(false);
      setRuleState(RULE_EMPTY_STRING);
    }
  }, [selectedItem]);

  useEffect(() => {
    if (ruleState && ruleState.endsWith("/")) {
      setShowMath(false);
      setDynamicCommandOption([]);
      setShowSelectOptions(true);
      setPropName(RULE_EMPTY_STRING);
    } else {
      setShowSelectOptions(false);
    }
    setFocusToInput();
  }, [ruleState]);

  // useEffect(()=>{
  //   scrollToBottom()
  // },[showSelectOptions, dynamicCommandOption, createRule])

  const fetchEditState = () => {
    let prevRules;
    const categoryItem = selectedItem as TProductCategory;
    const belongsToDataModel = isCategoryFeature
      ? !!categoryItem?.data?.belongsToDataModel
      : !!(
          selectedItem &&
          "belongsToDataModel" in selectedItem &&
          selectedItem?.belongsToDataModel
        );
    if (belongsToDataModel) {
      prevRules = isCategoryFeature
        ? userProjectDataModels?.project.dataModels[
            indexInfo?.dataModelIndex ?? -1
          ]?.data.productCategories[indexInfo?.categoryIndex ?? -1]?.data
            ?.rules ?? []
        : userProjectDataModels?.project.dataModels[
            indexInfo?.dataModelIndex ?? -1
          ]?.data.fields[indexInfo?.fieldIndex ?? -1]?.rules ?? [];
    } else if (isCategoryFeature) {
      prevRules =
        userProjectDataModels?.project.productCategories[
          indexInfo?.categoryOutsideDataModelIndex ?? -1
        ]?.data?.rules ?? [];
    } else {
      prevRules =
        userProjectDataModels?.project.fields[
          indexInfo?.fieldOutsideDataModelIndex ?? -1
        ]?.data?.rules ?? [];
    }
    if (Array.isArray(prevRules)) {
      const ruleObj = prevRules.filter((rule: any) => {
        return rule.id == editId;
      });
      setRules(prevRules);
      if (ruleObj.length > 0) {
        setRuleobj(ruleObj[0]);
        setRuleState(ruleObj[0].ruleExp);
        setRuleName(ruleObj[0].name);
        setDescription(ruleObj[0].description);
        setUseSelectedItemAttribute(ruleObj[0].useSelectedItemAttribute ?? false);
        setRuleScope(ruleObj[0].ruleScope);
      }
    }
    setCreateRule(false);
  };

  // const scrollToBottom = () => {
  //   if (selectRef) selectRef.scrollIntoView({ behavior: "smooth" });
  // };

  const setFocusToInput = () => {
    if (inputRef) inputRef.focus();
  };

  const getSubModelsList = () => {
    const localCommand = userProjectDataModels.project.dataModels.filter(
      (userProjectObject) => userProjectObject.type === RULE_FUNCTION_SUBMODEL
    );
    const retlocalCommand = localCommand.map((command) => {
      return {
        id: command.id,
        label: command.data.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_SUBMODEL,
        type: command.type,
      };
    });
    return retlocalCommand;
  };

  const getSubModelsFieldsList = (id: any) => {
    let localFieldModel = userProjectDataModels?.project.dataModels.filter(
      (model) => model.id == id
    );
    let localFields = localFieldModel[0]?.data?.fields ?? [];
    let retlocalFields = localFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_SUBMODEL_FIELD,
        type: command.type,
      };
    });
    return retlocalFields;
  };

  const getSubModelsFieldsChoiceList = (id: any) => {
    let localFields =
      mergeFieldList ??
      userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]
        ?.data.fields ??
      [];
    let subModel = userProjectDataModels?.project.dataModels[indexInfo?.dataModelIndex ?? -1]?.id
    let fieldObject = localFields.filter((x) => x.id == id);
    let optionToMap;
    if (fieldObject.length > 0) {
      optionToMap = fieldObject[0];
      let retlocalFields = optionToMap?.dataConfiguration?.choices?.map(
        (command: TAttributeChoice) => {
          return {
            id: command.av_id ?? command.id,
            label: command.av_value ?? command.value,
            description: RULE_EMPTY_STRING,
            hasOptions: false,
            child: [],
            choiceType: RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
            type: MULTI_CHOICE,
            field: id,
            subModel: subModel
          };
        }
      );
      return retlocalFields;
    }
    // else{
    //   let rootFields = userProjectDataModels?.project.fields.filter(x=>x.id == id)
    //   console.log(rootFields)
    //   optionToMap = rootFields[0]
    //   let retlocalFields = optionToMap?.data.dataConfiguration?.choices?.map(command => {
    //     return {
    //       id: command.av_id,
    //       label: command.av_value,
    //       description: RULE_EMPTY_STRING,
    //       hasOptions: false,
    //       child: [],
    //       choiceType: RULE_FUNCTION_SUBMODEL_FIELD_CHOICE,
    //       type:MULTI_CHOICE
    //     }
    //   })
    //   return retlocalFields
    // }
  };

  const getFieldsList = () => {
    let localFields = userProjectDataModels?.project.fields ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id };
    });
    let submodelFieldList: TField[] = [];
    userProjectDataModels?.project?.dataModels?.map((subModels) => {
      submodelFieldList.push(
        ...subModels?.data?.fields?.map((y) => {
          const localObj = { ...y };
          localObj.name = `"${subModels.data.name}"."${y.name}"`;
          localObj.subModel = subModels?.id
          return localObj;
        })
      );
    });
    let mergeFields = [...newlocalFields, ...submodelFieldList];
    setMergeFieldList(mergeFields);
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_FIELD,
        type: command.type,
        subModel: command?.subModel
      };
    });
    return retlocalFields;
  };

  const getCategoryList = () => {
    let localFields = userProjectDataModels?.project?.productCategories ?? [];
    const newlocalFields = localFields.map((x) => {
      return { ...x.data, id: x.id, type: x.type };
    });
    let submodelCategoryList: any[] = [];
    userProjectDataModels?.project?.dataModels?.forEach((subModels) => {
      subModels?.data?.productCategories?.forEach((y) => {
        submodelCategoryList.push({
          ...y.data,
          name: `"${subModels.data.name}"."${y.data.name}"`,
          id: y.id,
          subModel: subModels?.id,
        });
      });
    });
    let mergeFields = [...newlocalFields, ...submodelCategoryList];
    let retlocalFields = mergeFields.map((command) => {
      return {
        id: command.id,
        label: command?.name,
        description: RULE_EMPTY_STRING,
        hasOptions: false,
        child: [],
        choiceType: RULE_FUNCTION_CATEGORY,
        type: command?.type,
        subModel: command?.subModel,
      };
    });
    return retlocalFields;
  };

  const updateRules = (localRules: RuleObjectStateType[]) => {
    setUserProjectDataModels((prevDataModels) => {
      const newDataModels = { ...prevDataModels };
      const newRules: RuleObjectType[] = localRules.map((x) => {
        if (x.type === ruleType)
          return {
            id: x.id,
            ruleExp: x.ruleExp,
            ruleScope: x.ruleScope ?? {},
            name: x.name,
            description: x.description ?? RULE_EMPTY_STRING,
            useSelectedItemAttribute: x.useSelectedItemAttribute ?? false,
            type: x.type,
          };
        else return x;
      });
      const categoryItem = selectedItem as TProductCategory;
      const belongsToDataModel = isCategoryFeature
        ? !!categoryItem?.data?.belongsToDataModel
        : !!(
            selectedItem &&
            "belongsToDataModel" in selectedItem &&
            selectedItem?.belongsToDataModel
          );

      if (belongsToDataModel) {
        const dataModelToUpdate =
          newDataModels.project.dataModels[indexInfo?.dataModelIndex ?? -1];
        if (isCategoryFeature) {
          const categoryToUpdate =
            dataModelToUpdate?.data?.productCategories?.[
              indexInfo?.categoryIndex ?? -1
            ];
          if (categoryToUpdate && categoryToUpdate.data) {
            categoryToUpdate.data.rules = newRules;
          }
        } else if (
          dataModelToUpdate &&
          dataModelToUpdate.data &&
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1]
        ) {
          dataModelToUpdate.data.fields[indexInfo?.fieldIndex ?? -1].rules =
            newRules;
        }
      } else if (isCategoryFeature) {
        const categoryToUpdate =
          newDataModels.project.productCategories[
            indexInfo?.categoryOutsideDataModelIndex ?? -1
          ];
        if (categoryToUpdate && categoryToUpdate.data) {
          categoryToUpdate.data.rules = newRules;
        }
      } else {
        const fieldToUpdate =
          newDataModels.project.fields[
            indexInfo?.fieldOutsideDataModelIndex ?? -1
          ];
        if (fieldToUpdate && fieldToUpdate.data) {
          fieldToUpdate.data.rules = newRules;
        }
      }
      return newDataModels;
    });
  };

  const handleOptionsClick = (optionObject: commandType) => {
    const rule = ruleState && ruleState.slice(0, -1);
    switch (optionObject.id) {
      case 0:
        setDynamicCommandOption(getSubModelsList());
        setRuleState(rule);
        break;
      case 1:
        setDynamicCommandOption(getFieldsList());
        setRuleState(rule);
        break;
      case 2:
        setDynamicCommandOption(getCategoryList());
        setRuleState(rule);
        break;
      case 3:
        break;
      case 4:
        break;
      case 5:
        setShowMath(true);
        setRuleState(rule);
        break;
      default:
        let localRuleState = rule + " " + optionObject.label + " ";
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
    }
  };

  const handleUpdatePropNameToRuleScope = (
    optionObject: any,
    concatString: string
  ) => {
    const id = optionObject?.id
    const type = optionObject?.type
    const submodel = optionObject?.subModel ? optionObject?.subModel : hierarchyObject?.subModel
    const field = optionObject?.field ? optionObject?.field : hierarchyObject?.field
    setRuleScope({
      ...ruleScope,
      [`${propName + concatString}`]: { id: id, type: type, subModel: submodel, field: field },
    });

    setPropName(RULE_EMPTY_STRING);
    setHierarchyObject({ subModel: '', category: '', field: '' })
  };

  const handleSubOptionsCLick = (optionObject: commandType) => {
    let localRuleState = ruleState;
    const addition = '"' + optionObject.label + '"';
    switch (optionObject.choiceType) {
      case RULE_FUNCTION_SUBMODEL:
        const submodelString = addition + ".";
        localRuleState = localRuleState + submodelString;
        setPropName(submodelString);
        setDynamicCommandOption(getSubModelsFieldsList(optionObject.id));
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, subModel: optionObject?.id }
          return newObj
        })
        setRuleState(localRuleState);
        break;
      case RULE_FUNCTION_SUBMODEL_FIELD:
        localRuleState = localRuleState + addition;
        const subModelFieldOptions = getSubModelsFieldsChoiceList(
          optionObject.id
        );
        setPropName(propName + addition);
        // if (!subModelFieldOptions)
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        handleUpdatePropNameToRuleScope(
          optionObject,
          addition
        );
        setDynamicCommandOption([]);
        setRuleState(localRuleState);
        break;
      case RULE_FUNCTION_FIELD:
        const fieldOptions = getSubModelsFieldsChoiceList(optionObject.id);
        setPropName(propName + optionObject.label);
        setHierarchyObject((prev: any) => {
          const newObj = { ...prev, field: optionObject?.id }
          return newObj
        })
        if (!fieldOptions)
          handleUpdatePropNameToRuleScope(
            optionObject,
            optionObject.label
          );
        setDynamicCommandOption(fieldOptions);
        setRuleState(localRuleState + optionObject.label);
        break;
      case RULE_FUNCTION_SUBMODEL_FIELD_CHOICE:
        const choiceString = "." + addition;
        localRuleState = localRuleState + choiceString;
        setPropName(propName + choiceString);
        handleUpdatePropNameToRuleScope(
          optionObject,
          choiceString
        );
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
      case RULE_FUNCTION_CATEGORY:
        // A submodel-qualified category's label already comes pre-quoted from
        // getCategoryList (e.g. `"SubModelOne"."CatOne"`) - wrapping it again in `addition`
        // would double-quote it. A standalone category's label is bare, so it still needs
        // `addition`'s quotes.
        const categoryString = optionObject.subModel ? optionObject.label : addition;
        localRuleState = localRuleState + categoryString;
        setPropName(propName + localRuleState);
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
      default:
        setRuleState(localRuleState);
        setDynamicCommandOption([]);
        break;
    }
  };

  // const handleCreateClickHandler = () => {
  //   setCreateRule(!createRule);
  // };

  const onChangeHandler = (e: any, type = RULE_FUNCTION_PARENT) => {
    if (type === RULE_FUNCTION_CHILD) {
      if (e.includes(RULE_DONE)) {
        setShowMath(false);
        setFocusToInput();
        return;
      }
      if (e.includes(RULE_ADD_FIELD)) {
        setShowMath(false);
        setShowSelectOptions(true);
        setDynamicCommandOption([]);
        setFocusToInput();
        return;
      }
      setRuleState(e);
    } else {
      setRuleState(e.target.value);
    }
  };

  // const onEditHandler = (e: any, id: number) => {
    // if (editId == null) {
    //   setCreateRule(false);
    //   let localRules = rules.map((x) => {
    //     if (x?.id === id) {
    //       x.disabled = false;
    //       setRuleState(x.ruleExp);
    //       setRuleScope(x.ruleScope);
    //     }
    //     return x;
    //   });
    //   setRules(localRules);
    //   setEditId(id);
    // }
  //};

  const isValidMathExpression = (expression: string) => {
    try {
      // expression = expression.slice(expression.indexOf("=") + 1, expression.length)
      // // console.log(expression)
      // const parsed = parse(expression);
      // const symbols = parsed.filter((node: any) => node.isSymbolNode);
      // // console.log(symbols)
      // const scope = new Map();
      // symbols.forEach(function (x: any) {
      //   // if(KEYWORDS.includes(x.name)) scope.set(x?.name, math.sqrt)
      //   if (!KEYWORDS.includes(x.name)) scope.set(x?.name, 10);
      // })
      // return parsed.evaluate(scope)
      const stack = [];
      const openingBrackets = ["(", "[", "{"];
      const closingBrackets = [")", "]", "}"];

      for (let i = 0; i < expression.length; i++) {
        const char = expression[i];

        if (openingBrackets.includes(char)) {
          stack.push(char);
        } else if (closingBrackets.includes(char)) {
          const correspondingOpeningBracket =
            openingBrackets[closingBrackets.indexOf(char)];

          if (
            stack.length === 0 ||
            stack.pop() !== correspondingOpeningBracket
          ) {
            return false;
          }
        }
      }

      return stack.length === 0;
    } catch (error) {
      return false;
    }
  };

  const onSaveHandler = (e: any, type: string) => {
    let localRules = [...rules];
    let message = RULE_EMPTY_STRING;
    if (type === RULE_EDIT) {
      message = RULE_UPDATE_MESSAGE;
      localRules = rules?.map((x) => {
        let newObj = { ...x };
        if (x.id === editId) {
          newObj.ruleExp = ruleState;
          newObj.ruleScope = ruleScope;
          newObj.name = ruleName;
          newObj.description = description;
          newObj.useSelectedItemAttribute = useSelectedItemAttribute;
        }
        return newObj;
      });
    } else {
      message = RULE_SAVE_MESSAGE;
      localRules.push({
        ruleExp: ruleState,
        name: ruleName,
        description: description,
        useSelectedItemAttribute: useSelectedItemAttribute,
        type: ruleType,
        ruleScope: ruleScope,
      });
    }
    if (ruleName) {
      if (ruleState) {
        if (isValidMathExpression(ruleState)) {
          setRules(localRules);
          setCreateRule(true);
          updateRules(localRules);
          resetState();
          toggleMenu();
          createISRProject(true);
          toast.success(message);
        } else {
          toast.info(RULE_VALIDATION_MESSAGE);
        }
      }
    } else toast.info(RULE_NAME_MANDATORY_MESSAGE);
  };

  const resetState = () => {
    setShowMath(false);
    setShowSelectOptions(false);
    setDynamicCommandOption([]);
    setRuleState(RULE_EMPTY_STRING);
    setRuleScope({});
    setRuleobj(null);
    setRuleName(RULE_EMPTY_STRING);
    setDescription(RULE_EMPTY_STRING);
    setUseSelectedItemAttribute(false);
  };

  const onInputChangeHandler = (e: any, type: string) => {
    if (type === RULE_FUNCTION_RULE_NAME) {
      setRuleName(e.target.value);
    } else {
      setDescription(e.target.value);
    }
  };

  return (
    /* The legacy cart-style global expanded at the call site onto role tokens
       (it hardcodes white/#e5e5ea and must never be re-skinned globally). */
    <div className="tw-rounded tw-bg-surface-sunken tw-box-border tw-w-full tw-h-screen tw-border tw-border-solid tw-border-edge tw-py-2 tw-px-4">
      {/* DS TextField forwards its ref to the native input, so the shared
          `setInputRef` focus wiring survives; the event is handed to the same
          `onInputChangeHandler` the natives called (value-first DS signature). */}
      <TextField
        label="Rule Name"
        required
        className="tw-m-2"
        value={ruleName ?? RULE_EMPTY_STRING}
        onChange={(_value, e) => { if (e) onInputChangeHandler(e, RULE_FUNCTION_RULE_NAME); }}
        data-testid="rules-mathrulecomponent-input-1"
        ref={(el) => setInputRef(el)}
      />
      <TextField
        label={RULE_DESCRIPTION}
        className="tw-m-2"
        value={description ?? RULE_EMPTY_STRING}
        onChange={(_value, e) => { if (e) onInputChangeHandler(e, RULE_FUNCTION_DESCRIPTION); }}
        data-testid="rules-mathrulecomponent-input-2"
        ref={(el) => setInputRef(el)}
      />
      <div ref={(el) => setSelectRef(el)}>
        <FieldTitle label={RULE_RULE} className="tw-ml-2" />
        <RuleInputComponent
          ruleState={ruleState}
          onChangeHandler={onChangeHandler}
          onSaveHandler={onSaveHandler}
          value={ruleObj}
          setInputRef={setInputRef}
        />
      </div>
      <Checkbox
        id="useSelectedItemAttribute"
        label={RULE_USE_SELECTED_ITEM_ATTRIBUTE}
        checked={useSelectedItemAttribute}
        onChange={(checked) => setUseSelectedItemAttribute(checked)}
        className="tw-m-2 tw-items-center"
        data-testid="rules-mathrulecomponent-input-3"
      />
      {showMath && (
        <MathOperator state={ruleState} handleState={onChangeHandler} />
      )}
      {showSelectOptions && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={commandOptions}
            onClickHandler={handleOptionsClick}
          />
        </div>
      )}
      {dynamicCommandOption && (
        <div
          ref={(el) => {
            setSelectRef(el);
          }}
        >
          <SelectOptionsView
            data={dynamicCommandOption}
            onClickHandler={handleSubOptionsCLick}
          />
        </div>
      )}
    </div>
  );
};

export default MathRuleComponent;
